import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const CTASection = ({ language }) => {
  const navigate = useNavigate();

  const content = {
    en: {
      title: "Ready to Source Premium African Coffee?",
      description: "Connect with us today to discuss your green coffee bean requirements and discover how WGIH can support your business growth.",
      primaryButton: "Contact Us",
      secondaryButton: "Browse Beans"
    },
    zh: {
      title: "准备采购优质非洲咖啡？",
      description: "立即与我们联系，讨论您的生咖啡豆需求，了解WGIH如何支持您的业务增长。",
      primaryButton: "联系我们",
      secondaryButton: "浏览咖啡豆"
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-primary/5">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
          {content?.[language]?.title}
        </h2>
        <p className="text-base md:text-lg text-muted-foreground mb-8 md:mb-10 leading-relaxed">
          {content?.[language]?.description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="default"
            size="lg"
            iconName="Mail"
            iconPosition="left"
            onClick={() => navigate('/contact')}
          >
            {content?.[language]?.primaryButton}
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="Coffee"
            iconPosition="left"
            onClick={() => navigate('/browse-beans')}
          >
            {content?.[language]?.secondaryButton}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;